import { jsx as r } from "react/jsx-runtime";
const u = ({ index: t, onClick: a, style: e, isActive: o }) => /* @__PURE__ */ r(
  "button",
  {
    style: e,
    onClick: a,
    "data-active": o
  },
  t
);
export {
  u as default
};
